import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from "@angular/router";
import { Link } from "../directives/link";
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-didache',
  imports: [RouterLink, Link],
  templateUrl: './didache.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './didache.scss',
})
export class Didache {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Didache`);
    this.dynamicTitle.description(`The Didache is an anonymous composite letter containing early rituals, ethics, and Church organization.`);
  }
}
